import { Button, FormDataConsumer, ReferenceInput, required, SelectInput, useNotify } from "react-admin";
import AddBoxIcon from "@mui/icons-material/AddBox";
import dataProvider from "server/dataProvider";
import { activityRequests } from "api/activityApi";
import FormModal from "server/components/Modals/FormModal";
import { studentRequests } from "api/studentApi";

const AddSportScheduleDialog = ({
  fetchSportActivities,
  educationId,
  curriculumId,
  instructionLanguageId,
  studyTypeId,
}) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    const payload = {
      academicSessionId: data.academicSessionId,
      sportActivityId: data.sportActivityId,
    };
    await dataProvider.customRequest(activityRequests.studentSportActivities(educationId), payload, "POST");
    fetchSportActivities();
    notify("Успешно добавихте разписание за студента", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Добави разписание за спорт"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<AddBoxIcon />}
          size="small"
          label="Добави"
        />
      }
    >
      <FormDataConsumer>
        {({ formData }) => {
          return (
            <>
              <ReferenceInput
                source="academicYearId"
                reference={studentRequests.getAcademicYearsSelect()}
              >
                <SelectInput
                  label="Учебна година"
                  validate={required()}
                />
              </ReferenceInput>

              <ReferenceInput
                source="academicSessionId"
                reference={studentRequests.getAcademicSessionsSelect()}
                filter={{
                  onlySemesters: true,
                  curriculumId,
                  instructionLanguageId,
                  studyTypeId,
                }}
              >
                <SelectInput
                  label="Семестър"
                  optionText="sessionTypeText"
                  emptyText={false}
                  validate={required()}
                />
              </ReferenceInput>
              <ReferenceInput
                reference={activityRequests.getActivitySportSelect()}
                source="sportId"
              >
                <SelectInput
                  label="Избор на спорт"
                  optionText="nameBg"
                  emptyText={false}
                />
              </ReferenceInput>
              {formData.academicYearId && formData.academicSessionId && (
                <ReferenceInput
                  source="sportActivityId"
                  reference={`activity/students/${educationId}/sports/activities/select`}
                  filter={{
                    AcademicSessionId: formData.academicSessionId,
                    SportId: formData.sportId,
                  }}
                >
                  <SelectInput
                    label="Спортно разписание"
                    optionValue="id"
                    optionText={choice => {
                      if (!choice) return "";
                      const start = choice.startTime?.slice(0, 5);
                      const end = choice.endTime?.slice(0, 5);
                      return `${choice.sportName} | ${choice.buildingName} | ${choice.roomName} | ${start}ч. - ${end}ч.`;
                    }}
                    validate={[required()]}
                  />
                </ReferenceInput>
              )}
            </>
          );
        }}
      </FormDataConsumer>
    </FormModal>
  );
};

export default AddSportScheduleDialog;
